import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useRestaurant } from "@/hooks/useRestaurant";

/**
 * Tiny live revenue pill rendered above the merchant bottom nav.
 * Polls every 90s. Hidden when revenue is 0 or restaurant missing.
 */
export default function TodayRevenuePill() {
  const { restaurant } = useRestaurant();
  const [cents, setCents] = useState<number | null>(null);

  useEffect(() => {
    if (!restaurant?.id) return;
    let cancelled = false;
    const load = async () => {
      const today = new Date().toISOString().slice(0, 10);
      const { data } = await (supabase.from("vouchers") as any)
        .select("restaurant_payout_cents, paid_amount_cents, redeemed_at")
        .eq("restaurant_id", restaurant.id)
        .gte("redeemed_at", `${today}T00:00:00`)
        .not("redeemed_at", "is", null);
      if (cancelled) return;
      const sum = (data || []).reduce(
        (s: number, v: any) => s + (v.restaurant_payout_cents || v.paid_amount_cents || 0),
        0
      );
      setCents(sum);
    };
    load();
    const t = setInterval(load, 90_000);
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    return () => {
      cancelled = true;
      clearInterval(t);
      window.removeEventListener("focus", onFocus);
    };
  }, [restaurant?.id]);

  if (!cents || cents <= 0) return null;
  const eur = (cents / 100).toLocaleString("de-DE", { maximumFractionDigits: 0 });

  return (
    <div
      aria-label={`Heute ${eur} Euro Umsatz`}
      className="pointer-events-none fixed left-1/2 -translate-x-1/2 z-[59] lg:hidden flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-foreground/95 text-background text-[10px] font-black shadow-lg backdrop-blur"
      style={{ bottom: "calc(env(safe-area-inset-bottom) + 72px)" }}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-success animate-pulse" />
      Heute {eur} €
    </div>
  );
}
